/**
 * F-2 發布清單（admin.release_manifest 權限；AC-F2-1~5）。
 *
 * 注意 asset / diff 的 wire shape 是 camelCase（`assetId` / `mediaType` /
 * `releaseId`），與本專案多數 snake_case 端點不同——如實對齊 BE，不做轉換。
 */

import { apiFetch } from './core';

export type ReleaseManifestTargetType = 'display' | 'boat_host' | 'kiosk_media' | 'all';
export type ReleaseManifestState = 'staging' | 'active' | 'archived';

/** release manifest 摘要 — 對齊 BE ReleaseManifestRecord。 */
export interface ReleaseManifestRecord {
  id: string;
  release_id: string;
  content_version: string;
  target_type: ReleaseManifestTargetType;
  required_locales: string[];
  signature: string;
  signing_key_id: string;
  state: ReleaseManifestState;
  activated_at: string | null;
  archived_at: string | null;
  created_at: string;
}

/** manifest asset — 對齊 BE ReleaseManifestAsset（camelCase wire shape）。 */
export interface ReleaseManifestAsset {
  assetId: string;
  locale: string;
  mediaType: string;
  sha256: string;
  size: number;
  required: boolean;
}

/** per-target diff 結果 — missingAssets 僅含 required（AC-F2-3：optional 不入 missing list）。 */
export interface ReleaseManifestDiff {
  releaseId: string;
  targetId: string;
  targetCurrentVersion: string | null;
  missingAssets: Array<{ asset_id: string; locale: string; sha256: string }>;
  missingLocales: string[];
}

export function listReleaseManifests(limit = 100): Promise<{ items: ReleaseManifestRecord[] }> {
  return apiFetch<{ items: ReleaseManifestRecord[] }>(
    `/admin/release-manifests?limit=${encodeURIComponent(String(limit))}`,
    { method: 'GET' },
  );
}

export function getReleaseManifestAssets(
  releaseId: string,
): Promise<{ items: ReleaseManifestAsset[] }> {
  return apiFetch<{ items: ReleaseManifestAsset[] }>(
    `/admin/release-manifests/${encodeURIComponent(releaseId)}/assets`,
    { method: 'GET' },
  );
}

export function getReleaseManifestDiff(
  releaseId: string,
  targetId: string,
): Promise<ReleaseManifestDiff> {
  return apiFetch<ReleaseManifestDiff>(
    `/admin/release-manifests/${encodeURIComponent(releaseId)}/diff?target_id=${encodeURIComponent(targetId)}`,
    { method: 'GET' },
  );
}
